import { createAsyncThunk } from '@reduxjs/toolkit';
import { getOrganizationsList } from 'services/api';
import type { OrganizationsListRequest } from 'services/api';

export const getOrganizationsListAction = createAsyncThunk(
  'organizations/getList',
  async (params: OrganizationsListRequest) => {
    try {
      return await getOrganizationsList(params);
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);
